// Author Liang Gang Qiang
// Date 2021-11-03 15:05:19

class MintalMesQualityProductionProject {
constructor({
        id = null,
        code = '',
        inspectObject = '',
        qualityProjectId = '',
        qualityProjectName = '',
        furnaceBatchId = '',
        inspectType = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.inspectObject = inspectObject;
    this.qualityProjectId = qualityProjectId;
    this.qualityProjectName = qualityProjectName;
    this.furnaceBatchId = furnaceBatchId;
    this.inspectType = inspectType;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesQualityProductionProject();
}

const mintalMesQualityProductionProjectProductionVoConfigs = [
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualityProjectName',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.qualityProjectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'furnaceBatchCode',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.furnaceBatchCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectType',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.inspectType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '入厂检验' },
                            { value: '2', text: '上料检验' },
                            { value: '3', text: '球团成品检验' },
                            { value: '4', text: '铁水检验' },
                            { value: '5', text: '铁渣检验' },
                            { value: '6', text: '成品铁检验' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectObject',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.grid.inspectObject',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualityProjectName',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.grid.qualityProjectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectType',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.grid.inspectType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '入厂检验' },
                            { value: '2', text: '上料检验' },
                            { value: '3', text: '球团成品检验' },
                            { value: '4', text: '铁水检验' },
                            { value: '5', text: '铁渣检验' },
                            { value: '6', text: '成品铁检验' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.grid.remark',
        sortable: true,
        form: {
        type: 'textarea'
        }
        }
    ])}
const mintalMesQualityProductionProjectInventoryVoConfigs = [
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationTime',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.operationTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'orderCode',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.orderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'grade',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.grade',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualityProjectName',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.qualityProjectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectType',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.inspectType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '入厂检验' },
                            { value: '2', text: '上料检验' },
                            { value: '3', text: '球团成品检验' },
                            { value: '4', text: '铁水检验' },
                            { value: '5', text: '铁渣检验' },
                            { value: '6', text: '成品铁检验' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ]
const productionVoConfigs = [
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualityProjectName',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.qualityProjectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'furnaceBatchCode',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.furnaceBatchCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectType',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.inspectType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '入厂检验' },
                            { value: '2', text: '上料检验' },
                            { value: '3', text: '球团成品检验' },
                            { value: '4', text: '铁水检验' },
                            { value: '5', text: '铁渣检验' },
                            { value: '6', text: '成品铁检验' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    inspectObjectFilter : '',
    qualityProjectIdFilter : '',
    qualityProjectNameFilter : '',
    furnaceBatchIdFilter : '',
    inspectTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inspectObjectFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.filter.inspectObject',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualityProjectNameFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.filter.qualityProjectName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProject'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"qualityProjectId": "id"}'
                }
        },
        {
        key: 'inspectTypeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.filter.inspectType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '入厂检验' },
                { value: '2', text: '上料检验' },
                { value: '3', text: '球团成品检验' },
                { value: '4', text: '铁水检验' },
                { value: '5', text: '铁渣检验' },
                { value: '6', text: '成品铁检验' }
            ]
        }
        }
];
const mintalMesQualityProductionProjectProductionFilterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inspectObjectFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.filter.inspectObject',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                    ,onChangeDispatchAction:[
                'mintalMesPrdFurnaceBatch/retrieveSelectForSelectFilterChange'
            ]
            ,onChangeDispatchActionParams:[
                {selectFilterName:'prdResultId',selectEntityName:'mintalMesPrdFurnaceBatch'}
            ]
        }
        },
        {
        key: 'qualityProjectIdFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.filter.qualityProjectId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProject'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'furnaceBatchIdFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.filter.furnaceBatchId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdFurnaceBatch'
            ,showLabelSelectOne: true
                }
        },
];
const mintalMesQualityProductionProjectInventoryFilterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inspectObjectFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.filter.inspectObject',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesInventoryInputOutput'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'qualityProjectIdFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.filter.qualityProjectId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProject'
            ,correspondingField: 'id'
                }
        },
];


    const mintalMesQualityProductionProjectProductionEntityConfigs = [
        {
        key: 'inspectObject',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.entity.inspectObject',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                    ,onChangeDispatchAction:[
                'mintalMesPrdFurnaceBatch/retrieveSelectForSelectFilterChange'
            ]
            ,onChangeDispatchActionParams:[
                {selectFilterName:'prdResultId',selectEntityName:'mintalMesPrdFurnaceBatch'}
            ]
        }
        },
        {
        key: 'qualityProjectId',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.entity.qualityProjectId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'mintalMesQualityProject'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'furnaceBatchId',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.entity.furnaceBatchId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdFurnaceBatch'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'inspectType',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.entity.inspectType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '入厂检验' },
                { value: '2', text: '上料检验' },
                { value: '3', text: '球团成品检验' },
                { value: '4', text: '铁水检验' },
                { value: '5', text: '铁渣检验' },
                { value: '6', text: '成品铁检验' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectProduction.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]
    const mintalMesQualityProductionProjectInventoryEntityConfigs = [
        {
        key: 'inspectObject',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.entity.inspectObject',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'mintalMesInventoryInputOutput'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'qualityProjectId',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.entity.qualityProjectId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'mintalMesQualityProject'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionProjectInventory.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]
    const entityFormConfigs = [
        {
        key: 'inspectObject',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.entity.inspectObject',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualityProjectName',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.entity.qualityProjectName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProject'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"qualityProjectId": "id"}'
                }
        },
        {
        key: 'inspectType',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.entity.inspectType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '入厂检验' },
                { value: '2', text: '上料检验' },
                { value: '3', text: '球团成品检验' },
                { value: '4', text: '铁水检验' },
                { value: '5', text: '铁渣检验' },
                { value: '6', text: '成品铁检验' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionProject.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesQualityProductionProject, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, mintalMesQualityProductionProjectProductionFilterConfigs, mintalMesQualityProductionProjectInventoryFilterConfigs
, mintalMesQualityProductionProjectProductionEntityConfigs, mintalMesQualityProductionProjectInventoryEntityConfigs
, mintalMesQualityProductionProjectProductionVoConfigs, mintalMesQualityProductionProjectInventoryVoConfigs, productionVoConfigs
}
